module.exports = ".highlight{\r\n    background: #967d6df1;\r\n}\r\n\r\n.notseen{\r\n    background: #edf0f1eb;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/general-transaction/pigmy-manualcollection/pigmy-manualcollection.component.css
// module id = ./src/app/general-transaction/pigmy-manualcollection/pigmy-manualcollection.component.css
// module chunks = main